import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './MobileProfileFullNamePage.css';

const splitDisplayName = (user) => {
  const fn = (user?.firstName || '').trim();
  const ln = (user?.lastName || '').trim();
  if (fn || ln) return { first: fn, last: ln };
  const raw = (user?.name || user?.companyName || '').trim();
  if (!raw) return { first: '', last: '' };
  const parts = raw.split(/\s+/);
  if (parts.length === 1) return { first: parts[0], last: '' };
  return { first: parts[0], last: parts.slice(1).join(' ') };
};

const MobileProfileFullNamePage = () => {
  const navigate = useNavigate();
  const { user, updateProfile } = useAuth();

  const [first, setFirst] = useState('');
  const [last, setLast] = useState('');

  useEffect(() => {
    const s = splitDisplayName(user);
    setFirst(s.first);
    setLast(s.last);
  }, [user]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    setError(null);
    setSaving(true);
    try {
      const result = await updateProfile({
        firstName: first.trim(),
        lastName: last.trim(),
      });
      if (result.success) {
        navigate(-1);
      } else {
        setError(result.error || 'Save failed');
      }
    } catch (e) {
      setError(e?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mfn-page">
      <header className="mfn-header">
        <button type="button" className="mfn-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mfn-title">Full name</h1>
      </header>

      <div className="mfn-body">
        <div className="mfn-field-wrap">
          <span className="mfn-label">First name</span>
          <input
            className="mfn-input"
            id="mfn-first"
            value={first}
            onChange={(e) => setFirst(e.target.value)}
            autoComplete="given-name"
            placeholder=" "
            aria-label="First name"
          />
          {first && (
            <button type="button" className="mfn-clear" onClick={() => setFirst('')} aria-label="Clear first name">
              ×
            </button>
          )}
        </div>

        <div className="mfn-field-wrap">
          <span className="mfn-label">Last name</span>
          <input
            className="mfn-input"
            id="mfn-last"
            value={last}
            onChange={(e) => setLast(e.target.value)}
            autoComplete="family-name"
            placeholder=" "
            aria-label="Last name"
          />
          {last && (
            <button type="button" className="mfn-clear" onClick={() => setLast('')} aria-label="Clear last name">
              ×
            </button>
          )}
        </div>

        {error && <p className="mfn-err">{error}</p>}

        <button type="button" className="mfn-save" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default MobileProfileFullNamePage;
